"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseHandler = void 0;
const React = require("react");
const react_1 = require("react");
const FirebaseContext_1 = require("../../contexts/FirebaseContext");
/**
 * Provides access to a Firebase instance and its modules. Current modules that are supported include:
 *
 *  - Analytics
 */
const FirebaseHandler = ({ overrideConfig = null, children }) => {
    // firebase object to send tracking events for analytic purposes
    const [analytics, setAnalytics] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        const getFirebase = async () => {
            if (window.firebase) {
                // firebase already exists.
                return window.firebase;
            }
            else {
                // no firebase exists yet, import module.
                const firebase = await Promise.resolve().then(() => require("firebase/app"));
                await Promise.resolve().then(() => require("firebase/analytics"));
                // use the override config if exists or default to what's in the environment variables
                const config = overrideConfig || env;
                // if any configuration variable doesn't exists then we cannot initialize it
                if (!config.firebaseApiKey ||
                    !config.firebaseAuthDomain ||
                    !config.firebaseDbUrl ||
                    !config.firebaseProjectId ||
                    !config.firebaseStorageBucket ||
                    !config.firebaseMessagingSenderId ||
                    !config.firebaseAppId ||
                    !config.firebaseMeasurementId) {
                    throw new Error("Firebase environment variables not set.");
                }
                // set the actual configuration
                const firebaseConfig = {
                    apiKey: config.firebaseApiKey,
                    authDomain: config.firebaseAuthDomain,
                    databaseURL: config.firebaseDbUrl,
                    projectId: config.firebaseProjectId,
                    storageBucket: config.firebaseStorageBucket,
                    messagingSenderId: config.firebaseMessagingSenderId,
                    appId: config.firebaseAppId,
                    measurementId: config.firebaseMeasurementId
                };
                try {
                    // firebase must first be initialised with credentials before use
                    firebase.initializeApp(firebaseConfig);
                }
                catch (e) {
                    if (e && e.code === "app/duplicate-app") {
                        // this is fine, it's usually thrown when hot-reloading and means
                        // the app already exists, and does not need to be initialised.
                    }
                    else {
                        // not a 'duplicate app' error. rethrow.
                        throw e;
                    }
                }
                return firebase;
            }
        };
        // set the analytics object
        getFirebase().then(firebase => setAnalytics(firebase.analytics()));
    }, []);
    /**
     * Log an analytic event to Firebase
     */
    const logEvent = (0, react_1.useCallback)((eventName, data) => {
        if (!eventName) {
            return;
        }
        if (analytics) {
            data
                ? analytics.logEvent(eventName, data)
                : analytics.logEvent(eventName);
        }
    }, [analytics]);
    /**
     * Set the user of an application who is sending analytic events to Firebase
     */
    const setUserId = (0, react_1.useCallback)((value) => {
        if (!value) {
            return;
        }
        if (analytics) {
            analytics.setUserId(value);
        }
    }, [analytics]);
    const value = (0, react_1.useMemo)(() => ({
        logEvent,
        setUserId
    }), [logEvent, setUserId]);
    return (React.createElement(FirebaseContext_1.FirebaseContext.Provider, { value: value }, children));
};
exports.FirebaseHandler = FirebaseHandler;
//# sourceMappingURL=index.js.map